const AddIcon = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#000",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="6116"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M972.224719 460.224719H563.775281V51.775281a51.775281 51.775281 0 0 0-103.550562 0v408.449438H51.775281a51.775281 51.775281 0 0 0 0 103.550562h408.449438v408.449438a51.775281 51.775281 0 0 0 103.550562 0V563.775281h408.449438a51.775281 51.775281 0 0 0 0-103.550562z"
      fill={color}
      p-id="6117"
    ></path>
  </svg>
);

export default AddIcon;
